import { api } from '@/fsd/shared/api';

interface IParams {
  action: 'mark_read' | 'archive';
  target: 'single' | 'all';
  notification_id?: number;
}

export const putNotificationRead = async ({
  action,
  target,
  notification_id,
}: IParams): Promise<void> => {
  await api.put('/api/v1/notification/read/', {
    body: {
      action,
      target,
      notification_id,
    },
  });
};
